import React from "react"

import { graphql, useStaticQuery, Link } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import { getImage } from "gatsby-plugin-image"
import { convertToBgImage } from "gbimage-bridge"

import "./hero.css"

const QuandaryConnect = () => {
  // const { heroImage } = useStaticQuery(
  //   graphql`
  //     {
  //       heroImage: file(
  //         relativePath: { eq: "new-images/quandary-connect-banner.jpg" }
  //       ) {
  //         childImageSharp {
  //           gatsbyImageData(
  //             width: 1920
  //             layout: CONSTRAINED
  //             formats: [AUTO, WEBP, AVIF]
  //           )
  //         }
  //       }
  //     }
  //   `
  // )

  // const heroImageData = getImage(heroImage)

  // Use like this:
  // const bgImage = convertToBgImage(heroImageData)

  return (
    <>
      <div
        // Tag="div"
        // {...bgImage}
        // fluid={imageData}
        className="hero-banner hero-whitefade-connect-banner"
        // preserveStackingContext
        style={{ backgroundPosition: "top center" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-7 mr-auto">
              <div
                className="hero-procurement"
                style={{ margin: "13rem 0 10.5rem" }}
              >
                <h5 className="text-light-blue text-uppercase font-weight-bold mt-0 mb-4">
                  QUANDARY CONNECT
                </h5>
                <h1 className="page-title font-weight-medium mb-3">
                  Get Clear Data Insights at a Glance with Integrated Systems
                </h1>
                <p>
                  Reduce time-consuming, manual data entry and free yourself
                  from stressful, chaotic workflows filled with unnecessary risk
                  and avoidable mistakes.
                </p>
                <p>
                  <Link
                    aria-label="link"
                    className="font-weight-medium"
                    to="/contact/"
                  >
                    Speak to a Technology Consultant
                    <i className="ml-2 item-arrow" aria-hidden="true"></i>
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default QuandaryConnect
